<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start" class="navbar-back">
      <ion-button (click)="back()">
        <ion-icon name="chevron-back-outline"></ion-icon> Zurück
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center navbar-title">Adresse ändern</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <form (ngSubmit)="onSaved()">

    <ion-segment value="address" #addressSegment class="addr-segment">
      <ion-segment-button value="address">
        <ion-label>Rechnungsadresse</ion-label>
      </ion-segment-button>
      <ion-segment-button value="delivery">
        <ion-label>Lieferadresse</ion-label>
      </ion-segment-button>
    </ion-segment>

    <!-- Rechnungsadresse -->
    <div *ngIf="addressSegment.value === 'address'" class="addr-form">
      <div class="addr-field">
        <label class="addr-label">Name</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="address.name" name="name"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Zusatz (Optional)</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="address.supplement" name="supplement"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Straße</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="address.street" name="street"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Stadt</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="address.city" name="city"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">PLZ</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="address.zip" name="zip"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Ländercode</label>
        <ion-input fill="solid" class="addr-input" [readonly]="true" [(ngModel)]="address.countryCode" name="countryCode"></ion-input>
      </div>
    </div>

    <!-- Lieferadresse -->
    <div *ngIf="addressSegment.value === 'delivery'" class="addr-form">
      <div class="addr-field">
        <label class="addr-label">Firmenname</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.companyName" name="deliveryCompanyName"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Kontaktperson</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.contactPerson" name="deliveryContactPerson"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Adresszusatz</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.supplement" name="deliverySupplement"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Straße</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.street" name="deliveryStreet"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">PLZ</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.zip" name="deliveryZip"></ion-input>
      </div>
      <div class="addr-field">
        <label class="addr-label">Stadt</label>
        <ion-input fill="solid" class="addr-input" [(ngModel)]="deliveryAddress.city" name="deliveryCity"></ion-input>
      </div>
    </div>

    <div class="addr-save">
      <ion-button type="submit" expand="block">Speichern</ion-button>
    </div>

  </form>
</ion-content>
